import React from 'react';
import { PieChartData } from '../../types';
import './PieChart.css';

interface PieChartProps {
  data: PieChartData[];
  title?: string;
}

export const PieChart: React.FC<PieChartProps> = ({ data, title }) => {
  const total = data.reduce((sum, d) => sum + d.value, 0);
  if (total === 0) {
    return (
      <div className="admin-pie-chart">
        {title && <h3 className="admin-pie-chart__title">{title}</h3>}
        <p className="admin-pie-chart__empty">No data available</p>
      </div>
    );
  }

  // Build conic-gradient stops
  let accumulated = 0;
  const gradientStops = data.map(item => {
    const start = accumulated;
    const percent = (item.value / total) * 100;
    accumulated += percent;
    return `${item.color} ${start}% ${accumulated}%`;
  });

  const gradient = `conic-gradient(${gradientStops.join(', ')})`;

  return (
    <div className="admin-pie-chart">
      {title && <h3 className="admin-pie-chart__title">{title}</h3>}
      <div className="admin-pie-chart__container">
        <div
          className="admin-pie-chart__circle"
          style={{ background: gradient }}
          role="img"
          aria-label={title || 'Pie chart'}
        />
      </div>
      <div className="admin-pie-chart__legend">
        {data.map((item, index) => (
          <div key={index} className="admin-pie-chart__legend-item">
            <span
              className="admin-pie-chart__legend-color"
              style={{ backgroundColor: item.color }}
            />
            <span className="admin-pie-chart__legend-label">{item.label}</span>
            <span className="admin-pie-chart__legend-value">
              {item.value} ({Math.round((item.value / total) * 100)}%)
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};
